import { useLanguage } from '../../../contexts/LanguageContext';

export default function Vision() {
  const { t } = useLanguage();

  return (
    <section
      id="vision"
      className="relative py-32 overflow-hidden"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Ultra%20high%20resolution%20night%20Hong%20Kong%20skyline%20with%20illuminated%20modern%20glass%20skyscrapers%20and%20office%20buildings%20vibrant%20city%20lights%20glowing%20in%20warm%20orange%20yellow%20and%20red%20tones%20peaceful%20Victoria%20Harbor%20water%20reflecting%20colorful%20lights%20in%20foreground%20dark%20mountain%20silhouettes%20in%20background%20deep%20blue%20purple%20night%20sky%20with%20scattered%20stars%20professional%20architectural%20photography%20sharp%20details%20cinematic%20lighting%208K%20quality%20sophisticated%20urban%20atmosphere&width=1920&height=1080&seq=vision-hk-night-vibrant-lights-009&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/85 via-gray-900/75 to-gray-900/85"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-block px-6 py-2 bg-white/10 backdrop-blur-sm border border-white/30 rounded-full mb-8">
          <span className="text-white text-xs font-light tracking-widest uppercase">{t('我们的愿景', 'Our Vision')}</span>
        </div>

        <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-8" style={{ fontFamily: "'Noto Serif SC', serif" }}>
          {t('成为Z世代首选的', 'Become Gen Z\'s First Choice')}
          <br />
          {t('心灵智愈场', 'Mental Healing Sanctuary')}
        </h2>

        <p className="text-xl text-white/80 font-light mb-12 max-w-3xl mx-auto">
          {t(
            '重构"科技向善"的数字文化新生态，引领行业创新与发展',
            'Reconstructing a new digital culture ecosystem of "Technology for Good", leading industry innovation and development'
          )}
        </p>

        <div className="mb-16">
          <div className="inline-block relative">
            <i className="ri-double-quotes-l text-4xl text-teal-400 absolute -left-8 -top-4"></i>
            <p className="text-3xl text-white font-light italic px-8" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              {t('科技赋能情感，数字治愈心灵', 'Technology Empowers Emotions, Digital Heals the Soul')}
            </p>
            <i className="ri-double-quotes-r text-4xl text-teal-400 absolute -right-8 -bottom-4"></i>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-16">
          <div className="px-6 py-3 bg-gradient-to-r from-teal-500/30 to-teal-600/30 backdrop-blur-sm border border-teal-400/30 rounded-full">
            <span className="text-teal-300 text-sm font-light">{t('AI交互引擎', 'AI Interactive Engine')}</span>
          </div>
          <div className="px-6 py-3 bg-gradient-to-r from-purple-500/30 to-purple-600/30 backdrop-blur-sm border border-purple-400/30 rounded-full">
            <span className="text-purple-300 text-sm font-light">{t('个性化计算', 'Personalized Calculation')}</span>
          </div>
          <div className="px-6 py-3 bg-gradient-to-r from-pink-500/30 to-pink-600/30 backdrop-blur-sm border border-pink-400/30 rounded-full">
            <span className="text-pink-300 text-sm font-light">{t('二次元内容', '2D Content')}</span>
          </div>
          <div className="px-5 py-2.5 bg-gradient-to-r from-teal-500/30 to-purple-600/30 backdrop-blur-sm border border-teal-400/30 rounded-full">
            <span className="text-teal-200 text-xs font-light">{t('轻盈体验', 'Lightweight Experience')}</span>
          </div>
          <div className="px-7 py-3.5 bg-gradient-to-r from-purple-500/30 to-pink-600/30 backdrop-blur-sm border border-purple-400/30 rounded-full">
            <span className="text-purple-200 text-base font-light">{t('可持续发展', 'Sustainable Development')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
